/**
* Include your custom JavaScript here.
*
* We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
* changes on product page, you can attach a listener to the document:
*
* document.addEventListener('variant:changed', function(event) {
*   var variant = event.detail.variant; // Gives you access to the whole variant details
* });
*
* You can also add a listener whenever a product is added to the cart:
*
* document.addEventListener('product:added', function(event) {
*   var variant = event.detail.variant; // Get the variant that was added
*   var quantity = event.detail.quantity; // Get the quantity that was added
* });
*/
 
let
	localization_cookie = getCookie("localization"),
	cart_currency = getCookie("cart_currency");

(function() {
	    var touchingCarousel = false,
	      touchStartCoords;

	    document.body.addEventListener('touchstart', function(e) {
		      if (e.target.closest('.flickity-slider')) {
			        touchingCarousel = true;
		      } else {
			        touchingCarousel = false;
			        return;
		      }

		      touchStartCoords = {
			        x: e.touches[0].pageX,
			        y: e.touches[0].pageY
		      }
	    });

	    document.body.addEventListener('touchmove', function(e) {
		      if (!(touchingCarousel && e.cancelable)) {
			        return;
		      }

		      var moveVector = {
			        x: e.touches[0].pageX - touchStartCoords.x,
			        y: e.touches[0].pageY - touchStartCoords.y
		      };

		      if (Math.abs(moveVector.x) > 7)
			        e.preventDefault()

	    }, {passive: false});
  })();

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i=0; i<ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1);
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}  
	return "";  
}  

function setCookie(cname,cvalue,exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires=" + d.toGMTString();
	document.cookie = cname+"="+cvalue+"; "+expires+"; path=/";
}

function deleteCookie(name) {
	setCookie(name, "", null , null , null, 1);
}

function loadJSONProductColourSwatches(data) {
	$.ajax({
		url:	"/collections/all?view=json",
		type:	'GET'
	})
	.done(function(data) {
		//console.log($.parseJSON(data));

		$.each(JSON.parse(data).results, function(index, item) {
			// product_key and product_colour come from 'js-variables.liquid'
			//console.log(product_key+'//'+item.key);          
      
			item_title = item.title


			if (typeof item_title !== 'undefined' && item_title.indexOf("Chino Shorts") >= 0) {
				console.log(item_title);
			}

			if (typeof product_key !== 'undefined' && product_key == item.key) {

				//console.log(product_key+'//'+item.key + item.colour);

				var current_product = ""
				if( item.colour == product_colour) {
					current_product = " is-active"
				}

				$('.ProductForm__Variants .ProductItem__ColorSwatchList').append('<a href="'+item.url+'" data="'+item.colour+'" class="ColorSwatch  '+item.colour+current_product+'" style="background-color:'+item.colour+'; background-image:url('+item.swatch+')"></a>');
				//console.log('matched: '+ item.colour);
			}
		});
	})
	.fail(function(data) {})
	.always(function(data) {});
}


function loadJSONcollectionSwatches(data) {
	console.log('run script');

	$.ajax({
		url:	"/collections/"+collection_url+"?view=json",
		type:	'GET'
	})
	.done(function(data) {


		//console.log('test url: /collections/'+collection_url+'?view=json');
		console.log($.parseJSON(data));

		$.each(JSON.parse(data).results, function(index, item) {

			//console.log('compare key: '+item.key+' color: '+item.colour);


			//Find matching products and add swatches
			$('.ProductItem').each(function( index ) {
				var collection_product_key = $(this).find('.ProductItem__Title').text().trim();
				var collection_product_colour = $(this).find('.ProductItem__Colour').text().trim().replace('/','-').toLowerCase();

				//console.log('key: '+collection_product_key+' color: '+collection_product_colour);

				//console.log(item.colour+' // '+collection_product_colour);

				var current_product = ""
				if( item.colour == collection_product_colour ) {
					current_product = " is-active"
				}

				if (collection_product_key == item.key) {
          
					price = item.price
					price = '$'+price/100
          
					compare_at_price = item.compare_at_price
					compare_at_price = '$'+compare_at_price/100

					item_variants = '';
					$.each(item.variants, function(i, v) {
						//console.log(v)
						item_variants = item_variants + 'data-var_'+v.id+'="'+v.option1+':'+v.inventory_quantity+'" '
					});

					$(this).find('.ProductItem__ColorSwatchList').append('<a data-image="'+item.firstImage+'" data-image2="'+item.secondImage+'" '+item_variants+'data-url="'+item.url+'" data-colour="'+item.colour+'" class="ColorSwatch ColorSwatch--small '+item.colour+current_product+'" style="background-color:'+item.colour+'; background-image:url('+item.swatch+')" data-price="'+price+'" data-compare="'+compare_at_price+'"></a>');
				}
			});
		});


		$(swatchSlider);


	})
	.fail(function(data){})
	.always(function(data){});
}

if ($('body.template-collection').length > 0) {
	$(loadJSONcollectionSwatches);
}


function selected_variant(swatch) {
	swatch.parent().find("a").removeClass("is-active");
	swatch.addClass("is-active");

	const product_item = swatch.closest('.ProductItem');
	let = new_variants = ''
	$.each(swatch.data(), function(i, v) {
		//console.log(i)
	  
		if ( i.indexOf("var_") !== -1 ) {
			const
				v_id = i.replace('var_',''),
				v_data = v.split(':');
			let v_avail = ' class="unavailable" ';
			
			console.log( parseInt(v_data[1]) )
			
			if ( parseInt(v_data[1]) > 0 ){
				v_avail = ''
			}
			new_variants = new_variants + '<li><button type="button"'+v_avail+' value="'+v_id+'">'+v_data[0]+'</button></li>'
			//console.log(v)
		}
	});
	product_item.find(".product-size-list ul").html(new_variants);

	if(swatch.data("image")){
		var img_1 = product_item.find(".ProductItem__Image:eq(1)");
		var img_2 = product_item.find(".ProductItem__Image:eq(0)");
		img_1.attr("srcset", swatch.data("image"));
		img_2.attr("srcset", swatch.data("image2"));
	}

	product_item.find(".ProductItem__ImageWrapper, .ProductItem__Title a").attr('href', swatch.data("url"));
	product_item.find(".ProductItem__Colour").html(swatch.data('colour'));
  
	product_item.find(".FullPrice").html(swatch.data('price'));
	product_item.find(".Price--compareAt").html(swatch.data('compare'));

	if ( swatch.data('price') > swatch.data('compare') ) {
		product_item.find(".Price--compareAt").hide();
		product_item.find(".FullPrice").removeClass('Price--highlight');
	} else {
		product_item.find(".Price--compareAt").show();
		product_item.find(".FullPrice").addClass('Price--highlight');
	}

}


$('.ProductItem').on('click', '.ColorSwatch', function() {
	selected_variant($(this));
});

//Triggered from _rerenderCart in theme.js
const
	collection_promo_1 = document.getElementById('collection-promo-1'),
	collection_promo_2 = document.getElementById('collection-promo-2');
 
function update_collection_promos(){	
	if (window.location.href.indexOf("/collections/") > -1) {
		fetch(window.location.href+'/?sections=collection-template')
		.then(response => response.text())
		.then(html => {
			//console.log( JSON.parse(html) )
			parsedHTML = JSON.parse(html)
			//console.log(parsedHTML)    
			var page_html = 'collection-template'
			const parsedPage = parsedHTML[page_html]

			var parser = new DOMParser();
			var pageHTML = parser.parseFromString(parsedPage, 'text/html');

			const
				collection_promo_1_new = pageHTML.getElementById('collection-promo-1').innerHTML,
				collection_promo_2_new = pageHTML.getElementById('collection-promo-2').innerHTML;
										
			collection_promo_1.innerHTML = collection_promo_1_new;
			collection_promo_2.innerHTML = collection_promo_2_new;
		
		})
		.catch(e => {
			console.error(e);
		});
	}
}

function update_cart_gwp(){
	
	const cart_form = document.querySelector('form.Drawer__Content');
	
	const
	progress_header = cart_form.querySelector('.goal-progress-header'),
	progress_bar = cart_form.querySelector('.bar'),
	progress_1 = cart_form.querySelector('.goal-1'),
	progress_2 = cart_form.querySelector('.goal-2'),
	progress_3 = cart_form.querySelector('.goal-3');
	
	if ( progress_header ) {
		const
		gift_type_1 = progress_header.getAttribute('gift_type_1'),
		gift_1_title = progress_header.getAttribute('gift_1_title'),
		gift_2_title = progress_header.getAttribute('gift_2_title'),
		gift_3_title = progress_header.getAttribute('gift_3_title');
		only_highest_tier = progress_header.getAttribute('only_highest_tier');

		let
		cart_price =  parseInt(progress_header.getAttribute('cart_price')),
		cart_total_price = parseInt(progress_header.getAttribute('cart_total_price')),
		threshold_in_cents_1 = parseInt(progress_header.getAttribute('threshold_in_cents_1')),
		threshold_in_cents_2 = parseInt(progress_header.getAttribute('threshold_in_cents_2')),
		threshold_in_cents_3 = parseInt(progress_header.getAttribute('threshold_in_cents_3')),
		triggered_goal_1 = false,
		triggered_goal_2 = false,
		triggered_goal_3 = false,
		next_goal = '',
		goal_prefix = 'a FREE ';
		
		const
		header_gwp_1 = document.querySelectorAll('.gwp_1'),
		header_gwp_2 = document.querySelectorAll('.gwp_2');
		header_gwp_3 = document.querySelectorAll('.gwp_3');
		
		let rate = 1
  	
		let gift_1_class = "";
		
		if ( cart_currency != 'AUD' ) {
			if ( gift_type_1 != 'shipping') {
				gift_1_class = "block";
				/* for markets
				threshold_in_cents_1 = threshold_in_cents_1 * exchange_rate; */
			}
			/* for markets
			threshold_in_cents_2 = threshold_in_cents_2 * exchange_rate;
			threshold_in_cents_3 = threshold_in_cents_3 * exchange_rate; */
		}
		
		const
		gwp_1_dff = (threshold_in_cents_1 - cart_price) / 100.00,
		gwp_2_dff = (threshold_in_cents_2 - cart_price) / 100.00;
		gwp_3_dff = (threshold_in_cents_3 - cart_price) / 100.00;
		
		let
		header_gwp_1_msg =  `You are <b>$<span data-money-convertible>${ gwp_1_dff.toFixed(2) }</span></b> away from <b class="${gift_1_class}">${gift_1_title.split(' - ')[0]}</b>`,
		header_gwp_2_msg =  `You are <b>$<span data-money-convertible>${ gwp_2_dff.toFixed(2) }</span></b> away from a <b class="block">FREE ${gift_2_title.split(' - ')[0]}</b>`;
		header_gwp_3_msg =  `You are <b>$<span data-money-convertible>${ gwp_3_dff.toFixed(2) }</span></b> away from a <b class="block">FREE ${gift_3_title.split(' - ')[0]}</b>`;
		
		if ( cart_price >= threshold_in_cents_1 && threshold_in_cents_1 != 0 ) {
			triggered_goal_1 = true;
			header_gwp_1_msg =  `You are eligible for<br/> <b>${gift_1_title.split(' - ')[0]}</b>`;
		}
		if ( cart_price >= threshold_in_cents_2 && threshold_in_cents_2 != 0 ) {
			triggered_goal_2 = true;
			header_gwp_2_msg =  `You are eligible for a FREE<br/> <b>${gift_2_title.split(' - ')[0]}</b>`;
		}
		if ( cart_price >= threshold_in_cents_3 && threshold_in_cents_3 != 0 ) {				
			triggered_goal_3 = true;
			header_gwp_3_msg =  `You are eligible for a FREE<br/> <b>${gift_3_title.split(' - ')[0]}</b>`;
		}
	
			
		//Goal progress message2
		if (triggered_goal_2) {
			next_goal = gift_3_title;
			next_threshold = threshold_in_cents_3;
		} else if (triggered_goal_1) {
			next_goal = gift_2_title;
			next_threshold = threshold_in_cents_2;
		} else {
			if (gift_type_1 === 'shipping') {
				goal_prefix = '';
				next_goal = 'Free Shipping';
			} else {
				next_goal = gift_1_title;
			}
			next_threshold = threshold_in_cents_1;
		}
	
		//console.log( cart_price )
		//console.log( next_threshold+' / '+exchange_rate)
		//next_threshold = next_threshold * exchange_rate;
		//console.log( next_threshold)  
		
		const paragraph = document.createElement('p');
		if (triggered_goal_3) {
			paragraph.innerHTML = 'Congrats, you have unlocked all free gifts!';
		} else if (next_goal === '' && gift_type_1 === 'shipping') {
			paragraph.innerHTML = 'Congrats, you have unlocked <b>FREE SHIPPING!</b>';
		} else if (next_goal !== '') {
			next_value = (next_threshold - cart_price) / 100.00;
			//console.log( next_value)
			paragraph.innerHTML = `You are <b>$<span data-money-convertible>${ next_value.toFixed(2) }</span></b> away from ${goal_prefix} <b>${next_goal.split(' - ')[0]}</b>`;
		}
		
		//console.log(progress_header)
		progress_header.innerHTML = paragraph.outerHTML;
		
		header_gwp_1.forEach(element => {
	  	element.innerHTML = header_gwp_1_msg;
		});
		header_gwp_2.forEach(element => {
	  	element.innerHTML = header_gwp_2_msg;
		});
		header_gwp_3.forEach(element => {
			element.innerHTML = header_gwp_3_msg;
		});
	
		//Goal progress bar
		let goal1D = threshold_in_cents_1 * 1.00;
		let goal2D = threshold_in_cents_2 * 1.00;
		let goal3D = threshold_in_cents_3 * 1.00;
	
		let maxGoal = goal1D;
	
		if (gift_3_title !== '') {
			maxGoal = goal3D;
		} else if (gift_2_title !== '') {
			maxGoal = goal2D; 
		}
	
		let goalPercent = 10000.00 / maxGoal;
		let goalTotal = cart_price / 100;
		goalPercent *= goalTotal;
	
		let goal1Percent = goal1D / maxGoal;
		goal1Percent *= 100;
		let goal2Percent = goal2D / maxGoal;
		goal2Percent *= 100;
	
		if ( progress_bar ) {
			//Pretty sure this isn't used anymore - should be removed?
			progress_bar.style.width = `${goalPercent}%`;
			if ( progress_1 ) {
				progress_1.style.right = `${100 - goal1Percent}%`;
			}
			if ( progress_2 ) {
				progress_2.style.right = `${100 - goal2Percent}%`;
			}
		}
		
		console.log('triggered_goal_3: '+triggered_goal_3);
		if ( triggered_goal_3 && only_highest_tier == 'true' ) {
			const gift_2_handle = progress_header.getAttribute('gift_2_handle');
			const gift_2_line = document.querySelector('[data-remove_handle="'+gift_2_handle+'"]')
			if (gift_2_line){
				gift_2_line.click();
			}
		}
	}
} 

$('.product-size-list').on('click', 'button', function() {
	select_variant = $(this).val()
	
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			quantity:1, 
			id: select_variant
		},
		success: function(res){
			console.log("added: " + select_variant );
			document.documentElement.dispatchEvent(new CustomEvent('product:added', {
				bubbles: true,
				detail: {
					variant: select_variant,
					quantity: 1
				}
			}));
			//update_collection_promos();
		},
		error: function(){
			// if it's not last one Move Along else update the cart number with the current quantity
			console.log('error')
		}
	});
	
});


function swatchSlider(data) {

	swatch_width = $('.ProductItem__SwatchContainer').width();

	$('.ProductItem__SwatchContainer').each(function() {
		inner_width = $(this).find('.ProductItem__ColorSwatchList').width();
		if(inner_width > swatch_width) {
			$(this).find('.swatch-right').show();
			$(this).attr('data-width', inner_width - swatch_width);

		}
	});
}

$('.swatch-right').click(function(){
	sc = $(this).closest('.ProductItem__SwatchContainer')
	s_position = sc.data('position')
	s_end = -Math.abs(sc.data('width'))

	s_position = s_position - swatch_width + 60

	sc.find('.ProductItem__ColorSwatchList').css('left', s_position+'px');
	sc.data('position', s_position);

	//console.log(s_position + ' // ' + s_end);

	if(s_position < s_end) {
		sc.find('.swatch-right').fadeOut();
	}
	sc.find('.swatch-left').fadeIn();
});

$('.swatch-left').click(function(){
	sc = $(this).closest('.ProductItem__SwatchContainer')
	s_position = sc.data('position')
	s_end = -Math.abs(sc.data('width'))

	s_position = s_position + swatch_width - 60

	sc.find('.ProductItem__ColorSwatchList').css('left', s_position+'px');
	sc.data('position', s_position);

	//console.log(s_position + ' // ' + s_end);


	if(s_position == 2) {
		sc.find('.swatch-left').fadeOut();
	}
	sc.find('.swatch-right').fadeIn();
});

$( document ).ready(function() {
	//Reorder collection size tags
	var $wrapper_desktop = $('.CollectionMain .Collapsible.size ul.Linklist');
	var $wrapper_mob = $('#collection-filter-drawer .Collapsible.size ul.Linklist');
	var order = ['xs', 's', 'm', 'l', 'xl', 'xxl', '6-10', '6-11', '28', '30', '31', '32', '33', '34', '35', '36', '37', '38'];

	$wrapper_desktop.find('.Linklist__Item').sort(function(a, b) {
		var aSize = $(a).data('value').toString(),
		bSize = $(b).data('value').toString();
		return order.indexOf(aSize) - order.indexOf(bSize);
	}).appendTo($wrapper_desktop);
  
	$wrapper_mob.find('.Linklist__Item').sort(function(a, b) {
		var aSize = $(a).data('value').toString(),
		bSize = $(b).data('value').toString();
		return order.indexOf(aSize) - order.indexOf(bSize);
	}).appendTo($wrapper_mob);
  
  
  
	//Reorder collection price tags
	var $wrapper_desktop = $('.CollectionMain .Collapsible.price ul.Linklist');
	var $wrapper_mob = $('#collection-filter-drawer .Collapsible.price ul.Linklist');
	var order = ['0-25', '25-50', '50-75', '75-100', '100-150', '150-200', '200-250', '250-300', '300-400'];

	$wrapper_desktop.find('.Linklist__Item').sort(function(a, b) {
		var aSize = $(a).data('value').toString(),
		bSize = $(b).data('value').toString();
		return order.indexOf(aSize) - order.indexOf(bSize);
	}).appendTo($wrapper_desktop);
  
	$wrapper_mob.find('.Linklist__Item').sort(function(a, b) {
		var aSize = $(a).data('value').toString(),
		bSize = $(b).data('value').toString();
		return order.indexOf(aSize) - order.indexOf(bSize);
	}).appendTo($wrapper_mob);
});


//Count number of pages
$('.flickity-page-dots').each(function() {
	var myParent = $(this).children('.dot');
	total_pages = 0;
  
	$(myParent).each(function() {
		total_pages = total_pages + 1;
	});
                   
	$(this).closest('.Carousel').prevAll('.carousel-status').find('.total').html(total_pages);
});

/*Cousel click and potential touch - Prob not needed
$(document).on("click", ".Carousel", function(event) {
var theParent = $(this).find('.flickity-page-dots').children('.dot');
  
page_number = 1;
  
$(theParent).each(function() {
if ( $( this ).hasClass('is-selected') ) {
return false;
} else {
page_number = page_number + 1;
}
});

$(this).closest('.Carousel').prevAll('.carousel-status').find('.current').html(page_number);
});
*/

//Track Nav Clicks and Updated page number
$(document).ready(function() {

	//Move Next and Prev buttons to new location
	$(".flickity-prev-next-button.previous").each(function() {
		$(this).closest('.Carousel').prevAll('.carousel-status').find('.previous-slide').append(this);
	});

	$(".flickity-prev-next-button.next").each(function() {
		$(this).closest('.Carousel').prevAll('.carousel-status').find('.next-slide').append(this);
	});
  




	$('.ProductList--carousel').on("click", ".dot", function(event) {
		var theParent = $(this).parent('.flickity-page-dots').children('.dot').first();
		page_number = 1;
		if ( theParent.hasClass('is-selected') ) {
			return false;
		} else {
			page_number = page_number + 1;
		}

		$(this).closest('.ProductListWrapper').find('.current').html(page_number);
	});

});




$( document ).ready(function() {
	function setUp(){
		$(".collections-menu .parent-link").click(function(){
			if($(this).parent().find("ul").is(":visible"))
				$(this).removeClass("expanded");
			else
				$(this).addClass("expanded"); 
			$(this).parent().find("ul").slideToggle();
		});

		$('.collections-menu a.selected').closest('.top-level').find('a.parent-link').trigger('click').addClass('this');

		$(".toggle-filter-menu").click(function(e){
			e.preventDefault(); console.log("cjic");
			$('.collections-menu').toggleClass("expanded"); 
		});
	}

	setUp();
});

$('.close-AnnouncementBar').click(function(){
	$('#shopify-section-announcement').css('max-height','0px');
});


//Close drawer after 5 seconds when product added to cart
$('.ProductForm__AddToCart').click(function(){
	setTimeout(function() {
		$('#sidebar-cart .Drawer__Close').trigger('click');
	}, 5000);
});

$('#select-size-please .Button').click(function(){
	$('#select-size-please').fadeOut();
});


$(".Header__Logo").hover(function(){
	//$('.is-expanded').removeClass('is-expanded');
  
	//$('.Header__MainNav [aria-hidden="false"]').attr('aria-hidden', 'true');
});

$('.enquire-button').click(function(){
	$(this).hide();
	$('#contact_form').fadeIn();
});

function buildBundleItem(index, bundle_product, current_product, shop_data){

	//console.log(index) 
  
	$.getJSON('/products/' + current_product.handle, function (product) {
           
		var product = product.product
		product_title = product.title

		$bundleObject = $("<div>", {"class": "bundle-object", "data-product": bundle_product, "data-index": index});

		$bundle_img = $("<div>", {"class": "bundle-img"});
		$bundle_info = $("<div>", {"class": "bundle-info"});
		$bundle_sizes = $("<div>", {"class": "SizeSwatchList HorizontalList"});
		$bundle_colours = $("<div>", {"class": "ProductItem__ColorSwatchList"});

		$bundle_img.append('<img src="'+current_product.firstImage+'"/>')
		$bundle_info.append('<h2>'+bundle_product+'</h2>')


		$bundle_info.append('<span class="ProductForm__Label">Size</span>')

		$.each(product.variants, function(i, variant) {
      
			console.log(index) 

			var_title = variant.title
			var_title = var_title.split(' / ')[0]

			var_input = '<input class="SizeSwatch__Radio" type="radio" data-id="'+variant.id+'" id="swatch-'+variant.id+'-'+index+'" name="swatch-'+product.id+'-'+index+'">'

			var avilability = ''
			if (variant.inventory_quantity < 1) {
				var avilability = 'disabled';
			}

			var_label = '<label class="SizeSwatch '+avilability+'" for="swatch-'+variant.id+'-'+index+'">'+var_title+'</label>'

			$bundle_sizes.append('<li class="HorizontalList__Item">'+ var_input + var_label + '</p>')
		});

		$bundle_info.append($bundle_sizes)
		$bundle_info.append('<span class="ProductForm__Label">Colour</span>')


		product_key = product_title.split(' - ')[0]
		product_colour= product_title.split(' - ')[1].toLowerCase()

		$.each(JSON.parse(shop_data).results, function(i, item) {

			//console.log(product_key+'//'+item.key + item.colour);
      
			if (typeof product_key !== 'undefined' && product_key == item.key) {

				var current_product = ""
				if( item.colour == product_colour) {
					current_product = " is-active"
				}

				$bundle_colours.append('<button type="button" data-handle="'+item.handle+'" data-img="'+item.firstImage+'" class="ColorSwatch '+item.colour+current_product+'" style="background-color:'+item.colour+'; background-image:url('+item.swatch+')"></button>');
				//console.log('current: '+product_colour+' matched: '+ item.colour);
			}

		});
    
		$bundle_info.append($bundle_colours)

		$bundleObject.append($bundle_img, $bundle_info)
		$('.bundle-items').append($bundleObject)


	})
	.done(function() {
		//console.log( "second success" );
	})
	.fail(function() {
		console.log( "error" );
	})
	.always(function() {
	});
}

function loadBundles(shop_data) {

	$('.ProductForm').empty();
	$('.ProductForm').html('<div class="bundle-items"></div><div class="bundle-add"></div>');

	bundle_products = bundle_products.split(' / ')


	$.each(bundle_products, function(i, bundle_product) {
    
		//console.log(bundle_products)
		var index = i
		var found_product = false

		$.each(JSON.parse(shop_data).results, function(i, product) {
			//console.log(product)
      
			if ( found_product == false ) {
				product_key = product.key

				//console.log('bundle: '+bundle_product)
				//console.log('handle: '+product_key)

				if( typeof product_key != 'undefined' ) {
					if ( product_key.includes(bundle_product) ) {
						found_product = true
            
						//console.log('building:'+product.handle)
            
						buildBundleItem(index, bundle_product, product, shop_data)

					}
				}
			}
		});
	});
  
	$('.bundle-add').append('<button type="button" class="Button Button--primary Button--full">Add To Cart</button>');
}



function addProductsToCart(selected_variants){
	
	//console.log(bundle_items)
	let request = []
	Shopify.moveAlong = function() {
		if (selected_variants.length) {
			request = selected_variants.shift();

			dataObj = {        
				quantity: request.qty, 
				id: request.variant_id,
			};
			//console.log(dataObj)

			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: dataObj,
				success: function(res){
					console.log("added: " + dataObj);
					Shopify.moveAlong();
				},
				error: function(error){
					// if it's not last one Move Along else update the cart number with the current quantity
					if (Shopify.queue.length){
						Shopify.moveAlong()
					} else {
						console.log('error')
					}
				}
			});
		}
		else {
			// If the queue is empty, show confirmation popup
			console.log('completed - success')
			document.documentElement.dispatchEvent(new CustomEvent('product:added', {
				bubbles: true,
				detail: {
					variant: request.variant_id,
					quantity: request.qty
				}
			}));
		}
	};
	Shopify.moveAlong();	
};

$('.ProductForm').on('click', '.ProductItem__ColorSwatchList button', function() {  
	swatch = $(this)
	swatch.closest('.ProductItem__ColorSwatchList').find('button').removeClass('is-active');
	swatch.addClass('is-active');
	index = swatch.closest('.bundle-object').data('index')
  
	$.getJSON('/products/' + swatch.data('handle'), function (product) {
		var product = product.product

		swatch.closest('.bundle-object').find('img').attr('src',swatch.data('img'))
    
		size_wrapper = swatch.closest('.bundle-object').find('.SizeSwatchList')
    
		size_wrapper.empty()
    
		$.each(product.variants, function(i, variant) {

			var_title = variant.title
			var_title = var_title.split(' / ')[0]

			var_input = '<input class="SizeSwatch__Radio" type="radio" data-id="'+variant.id+'" id="swatch-'+variant.id+'-'+index+'" name="swatch-'+product.id+'-'+index+'">'

			var avilability = ''
			if (variant.inventory_quantity < 1) {
				var avilability = 'disabled';
			}

			var_label = '<label class="SizeSwatch '+avilability+'" for="swatch-'+variant.id+'-'+index+'">'+var_title+'</label>'

			size_wrapper.append('<li class="HorizontalList__Item">'+ var_input + var_label + '</p>')
		});
    
	});
});


$('.ProductForm').on('click', '.bundle-add button', function() {
	selected_variants = []

	$.each( $('.bundle-items input[type="radio"]:checked') , function(i, bundle_product) {
		//products_to_add = products_to_add + ',' + $(this).data('id');
		
		selected_variant = {
			qty: 1,
			variant_id: $(this).data('id')
		}
		selected_variants.push(selected_variant)
	});

	addProductsToCart(selected_variants);

});

function build_bundle(bundle_products){
	selected_size = $('.SizeSwatchList input:checked').val()

	selected_variants = []
	if ( typeof selected_size == 'undefined' ) {
		alert('Please select a size')
	} else {
		$.each(bundle_products, function(i, product) {
			
			const product_qty = product.qty;
			console.log(product_qty)
			const selected_qty = $('input[name="quantity"]').val();
			console.log(selected_qty)
			console.log(product_qty * selected_qty)
			
			$.each(product.variants, function(i, variant) {
				
				if ( variant.option1 == selected_size ) {
					selected_variant = {
						qty: product_qty * selected_qty,
						variant_id: variant.id
					}
					selected_variants.push(selected_variant)
				}
			});
		});
	}
	
	addProductsToCart(selected_variants);
}

if ($('.show-bundles-loading').length > 0) {
	$('.ProductForm').empty();
	//$('.ProductMeta__Description, .Product__QuickNav').hide();
	$('.variant-sku').hide();

	$('.ProductForm').html('<div class="loading-message"><p>Loading bundle products...</p><hr/><div>');
}

if ($('body.template-product').length > 0) {
	var shop_data = null  
	$.ajax({
		url:	"/collections/all?view=json",
		type:	'GET'
	})
	.done(function(data) {
		shop_data = data
	})
	.fail(function(data) {})
	.always(function(data) {

		if ( typeof bundle_products != 'undefined' && typeof bundle_type_1 != 'undefined' ) {
			if ( bundle_type_1 == true ) {
				$(loadBundles(shop_data));
			}
		} else {
			$(loadJSONProductColourSwatches);
		}
	});
}

$(document).on("click", "#add-fixed-bundle", function(event) {
	console.log('clicked');
	select_variant = $(this).closest('.ProductForm').find('input[type="radio"]:checked').val();
	
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			quantity:1, 
			id: select_variant
		},
		success: function(res){
			console.log("added: " + select_variant );
			document.documentElement.dispatchEvent(new CustomEvent('product:added', {
				bubbles: true,
				detail: {
					variant: select_variant,
					quantity: 1
				}
			}));
			//update_collection_promos();
		},
		error: function(){
			// if it's not last one Move Along else update the cart number with the current quantity
			console.log('error')
		}
	});
	
});


$('.Product_fit-features').detach().appendTo('#Product-fit-features-placeholder')
$('.Product_fabric').detach().appendTo('#Product-fabric-placeholder')

$('#toggle-desc').click(function(){
  $(this).hide().css("opacity", "0");;
  $('#toggle-desc-close').css("display", "block");
  $('.collection-desc').removeClass('truncated')
  setTimeout(function(){
    $('#toggle-desc-close').css("opacity", "0.5");
  }, 300);
});
$('#toggle-desc-close').click(function(){
  $(this).hide().css("opacity", "0");;
  $('#toggle-desc').css("display", "block");
  $('.collection-desc').addClass('truncated')
  setTimeout(function(){
    $('#toggle-desc').css("opacity", "0.5");
  }, 800);
});

function add_gift(select_variant){
	console.log('triggered')
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			quantity:1, 
			id: select_variant
		},
		success: function(res){
			console.log("added: " + select_variant );
			document.documentElement.dispatchEvent(new CustomEvent('product:added', {
				bubbles: true,
				detail: {
					variant: select_variant,
					quantity: 1
				}
			}));
			//update_collection_promos();
		},
		error: function(){
			// if it's not last one Move Along else update the cart number with the current quantity
			console.log('error')
		}
	});
}

$('#sidebar-cart').on('click', '.add-gift', function() {
	
	const form = $(this).closest('.free-gift-form');
		
	const selectedOption = form.find('select').val();
	add_gift(selectedOption)
});

if (typeof auto_add_gift !== 'undefined' && auto_add_gift != '') {
	add_gift(auto_add_gift)
}

$('#sidebar-cart').on('click', '.add-gift', function() {
	
	const form = $(this).closest('.free-gift-form');
		
	const selectedOption = form.find('select').val();
	add_gift(selectedOption)
});

// Select the cart drawer contents element
const sidebarCart = document.getElementById('sidebar-cart');


/* Disabled shipping protection

// Use event delegation to attach a change event listener
sidebarCart.addEventListener('change', function(event) {
	// Check if the event target is the checkbox
	if (event.target.id === 'ship-protect-check') { 
		if ( !event.target.checked) {
			// Checkbox is deselected, perform your desired action
			setCookie('shipping_protection', 'false', 1);
			const ship_protect_item = document.querySelector('[data-remove_handle="shipping-protection"]').click();	
		} else {
			add_gift(event.target.value);
		} 
	}
});

function check_ship_protect(recheck,event){
	const shipProtectCheck = document.getElementById('ship-protect-check');
	if (shipProtectCheck) {
		if ( getCookie("shipping_protection") != 'false' && !shipProtectCheck.checked ) {
			//console.log('lets add it!');
			shipProtectCheck.click();
		} else {
			//console.log('lets not?');		
		}
		
		//Check if item doesn't require shipping
		if (event?.detail?.variant?.requires_shipping !== undefined) {
			const requires_shipping = event.detail.variant.requires_shipping;
	
			if (!requires_shipping) {
				if (shipProtectCheck?.checked) {
					// Protection is checked; verify if the cart requires shipping
					fetch('/cart.js', {
						method: 'GET',
						headers: {
							'Content-Type': 'application/json',
						},
					})
					.then(response => {
						if (!response.ok) {
							throw new Error(`HTTP error! Status: ${response.status}`);
						}
						return response.json();
					})
					.then(cart => {
						if (cart.requires_shipping === false) {
							// Cart doesn't require shipping; remove protection
							shipProtectCheck.click();
						}
					})
					.catch(error => {
						console.error('Error fetching cart:', error);
					});
				}
			}
		}
		
	} else if (recheck) {
		setTimeout(() => {
			check_ship_protect(true);
		}, "1000");
	}
}

document.addEventListener('product:added', function(event) {
	check_ship_protect(true,event);
}); 
check_ship_protect(false)*/

/* Disable this for Markets */
const
	selected_currency = localStorage.getItem("currency"),
	selected_localization = getCookie('localization'),
	localization_select = $('#localization-select'),
	currency_options = 'US CA GB FR NZ';
let currency_code = 'AU'
if ( selected_currency == 'USD') {
	currency_code = 'US'
} else if ( selected_currency == 'CAD') {
	currency_code = 'CA'
} else if ( selected_currency == 'NZD') {
	currency_code = 'NZ'
} else if ( selected_currency == 'EUR') {
	currency_code = 'FR'
} else if ( selected_currency == 'GBP') {
	currency_code = 'GB'	
}
	
console.log( currency_code+'/'+selected_currency+'/'+selected_localization )	
//check_currency_country()
change_localization = false

if ( selected_currency == 'AUD' && currency_options.indexOf(selected_localization) != -1) {
	//If AUD selected but localization is US, CA or GB
	change_localization = true
}

if ( selected_currency != 'AUD' && selected_localization != currency_code ) {
	//If non AUD selected and localization doesn't match
	change_localization = true
}

if ( change_localization ) {
	console.log(currency_code)
	localization_select.find('option[value="'+ currency_code +'"]').prop('selected', true)
	localization_select.find('.Button').click()
}

const swiper = new Swiper('.AnnouncementBar__Slider', {
	loop: true,
	autoplay: {
		delay: 6000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true
	},
	effect: "fade",
	navigation: {
		nextEl: '.AnnouncementBar__next',
		prevEl: '.AnnouncementBar__prev',
	}
});

//Close Popup Windows
$('.popup-wrapper .close-popup').click(function() {
	$(this).closest('.popup-wrapper').fadeOut();
});

$(".popup-wrapper").click(function(e) {
	if(e.target !== e.currentTarget) return;
	e.preventDefault();
	$(this).fadeOut();
});

$('#product-popup-trigger').click(function(){
	$('#product-popup-content').show();
});

$('#product-popup-2-trigger').click(function(){
	$('#product-popup-2-content').show();
});

$('#about-popup-trigger').click(function(){
	$('#about-popup-content').show();
});

$('.view-extra-features').click(function(){
	if ( $(this).text() == 'Hide info') {
		$(this).text('View more info');		
	} else {
		$(this).text('Hide info');
	}

	$('.secondary-features').toggleClass('open');
});


$('.features-carousel').flickity({
	// options
	cellAlign: 'left',
	contain: true,
	prevNextButtons: false,
	groupCells: true
});

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

/* For Markets
let
exchange_data = getCookie("exchange_data"),
exchange_rate = 1;

exchange_data = exchange_data.split(':');

if ( exchange_data != '' ) {
	exchange_currency = exchange_data[0];
	exchange_rate = exchange_data[1];
}


if ( cart_currency != 'AUD' && cart_currency != 'USD'  ) {
	if ( exchange_data == '' || exchange_currency != cart_currency ) {
		
		//console.log('lets search:'+cart_currency)
		const local_price = parseInt(document.getElementById('exchange-rate').innerHTML);
		
		fetch('https://mrsimple.com.au/collections?country=AU')
		.then(response => response.text())
		.then(html => {
			//console.log( html )
			var parser = new DOMParser();
			var pageHTML = parser.parseFromString(html, 'text/html');

			const au_price = parseInt(pageHTML.getElementById('exchange-rate').innerHTML);		
	
			//console.log( 'local:'+ local_price + ' /  au_price:'+ au_price );	
	
			exchange_rate = local_price / au_price
		
			setCookie('exchange_data', cart_currency+':'+exchange_rate), 0.1;

			//console.log( 'exchange_data:'+ exchange_rate);	
			console.log( 'localization_cookie:'+localization_cookie)

			fetch('https://mrsimple.com.au/collections?country='+localization_cookie)
			.then(response => response.text())
			.then(html => {
				//All good cookie reset to NZ
				update_cart_gwp();
			})
			.catch(e => {
				console.error(e);
			});
		})
		.catch(e => {
			console.error(e);
		});
	}
} else {
	//console.log('have data')		
	//console.log( exchange_data )
}
*/
update_cart_gwp(); 


/*
console.log('url:'+window.location.href+'?country=AU')

fetch(window.location.href+'?country=AU')
.then(response => response.text())
.then(html => {
	//console.log( html )
	var parser = new DOMParser();
	var pageHTML = parser.parseFromString(html, 'text/html');

	const raw_price = pageHTML.getElementById('raw-price').innerHTML;		
	
	console.log( 'price:'+ raw_price)


})
.catch(e => {
	console.error(e);
});*/

/*
// Function to convert kg to lbs

//Built for Oct 2024, never used

function kgToLbs(kg) {
	//round to 2 decimals
	//return (kg * 2.20462).toFixed(2); // 1 kg = 2.20462 lbs
	
	//round to nearest whole numbers
	return Math.round(kg * 2.20462);
}

function cmToFeetInches(cm) {
	let totalInches = cm * 0.393701; // Convert cm to inches
	if ( cm > 140 ) {
		let feet = Math.floor(totalInches / 12); // Calculate the number of feet
		let inches = Math.round(totalInches % 12); // Get the remaining inches
	
		return `${feet}ft ${inches}in`;
	} else {
		let inches = totalInches.toFixed(1);
		return `${inches}"`;
	}
}

const size_tds = document.querySelectorAll('.Modal td, .Modal th');
// Function to find and convert kg strings in table
function convertKgToLbsInTable() {
		console.log('converting')
		
		// Regular expression to match strings like '40-50kg'
		let kgRegex = /(\d+)?-?(\d+)?kg/;
		let cmRegex = /(\d+)?-?(\d+)?cm/;
		let numberRegex = /^\d+(\.\d+)?$/;
		
		// Loop over all the <td> elements
		size_tds.forEach(function(td) {
				let text = td.textContent.trim(); 
				//console.log(text);
				// Check if the text matches the 'kg' format
				
				let matchKg = text.match(kgRegex);
				if (matchKg) {
					let min = parseFloat(matchKg[1]);
					let max = parseFloat(matchKg[2]);
					
					min = kgToLbs(min);
					max = kgToLbs(max);
					//td.textContent = `${min} - ${max}lbs`;
					td.setAttribute('data-cm', text); 
					
					if (max != 'NaN' && !isNaN(max)) {
						td.setAttribute('data-inch', `${min} - ${max}lbs`); 
					} else {
						td.setAttribute('data-inch', `${min}lbs`); 
					}
				}
				
				let matchCm = text.match(cmRegex);
				if (matchCm) {
					let min = parseFloat(matchCm[1]);
					let max = parseFloat(matchCm[2]);
					
					min = cmToFeetInches(min);
					max = cmToFeetInches(max);
					//td.textContent = `${min} - ${max}`;
					td.setAttribute('data-cm', text); 
					
					console.log( min );
					console.log( max );
					if (max != 'NaN"') {
						console.log('not nan;')
						td.setAttribute('data-inch', `${min} - ${max}`); 
					} else {
						console.log('is nan;')
						td.setAttribute('data-inch', min); 
					}
				}
				
				let matchNumber = text.match(numberRegex);
				if (matchNumber) {
					let number = parseFloat(matchNumber);
					
					number = cmToFeetInches(number);
					//td.textContent = `${min} - ${max}`;
					td.setAttribute('data-cm', text); 
					
					console.log( number );
					td.setAttribute('data-inch', number); 
				}
		});
}

// Run the conversion function
convertKgToLbsInTable();
*/

/*
Size convertor developed in Oct 2024 but never used
// Event listener for radio button changes
const switch_radios = document.querySelectorAll('input[name="switch-units"]');
console.log( switch_radios );
switch_radios.forEach(function(radio) {
	radio.addEventListener('change', function() {
		const selectedUnit = document.querySelector('input[name="switch-units"]:checked').value; // 'cm' or 'inch'
		//console.log('selectedUnit :'+selectedUnit)
		size_tds.forEach(function(td) {
			const newValue = td.getAttribute(`data-${selectedUnit}`);
			
			//console.log( newValue );
			if ( newValue ){
				td.textContent = newValue;
			}
		});
	});
});*/

document.querySelectorAll('.size-chart-units a').forEach(link => {
		link.addEventListener('click', function(event) {
				event.preventDefault(); // Prevent default link behavior if it's a link

				// Get the target unit from the clicked link's data-target attribute
				const targetUnit = this.getAttribute('data-target');

				// Find the closest .size-chart parent element
				const sizeChart = this.closest('.size-chart');

				if (sizeChart) {
						// Remove .active class from all tables within the .size-chart parent
						sizeChart.querySelectorAll('table').forEach(table => {
								table.classList.remove('active');
						});
						
						sizeChart.querySelectorAll('.size-chart-units a').forEach(table => {
								table.classList.remove('active');
						});
						this.classList.add('active');

						// Find the table with matching data-unit attribute and add the .active class
						const targetTable = sizeChart.querySelector(`table[data-unit="${targetUnit}"]`);
						if (targetTable) {
								targetTable.classList.add('active');
						}
				}
		});
});


//Collection infinity scrolling
const p_next = document.querySelector('.p-next');
const pag_wrap = document.querySelector('.Pagination');
if (p_next) {
	let pInfScrLoading = false;
	let pInfScrDelay = 100;
	let loadingCollection = false;
	
	function pInfScrExecute() {
		let loadingImage;
		loadingCollection = true;

		// Get the last .p-next node
		const pInfScrNode = document.querySelector('.p-next:last-of-type');

		if (pInfScrNode && !pInfScrLoading && window.getComputedStyle(pInfScrNode).display !== 'none') {
			const pInfScrURL = pInfScrNode.getAttribute('href');

			if (pInfScrURL) {
				pInfScrLoading = true;

				// Before sending: clone and insert loading image
				loadingImage = pInfScrNode.cloneNode(false);
				loadingImage.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0497/8277/files/loader.gif?v=1618948654" />';
				pag_wrap.insertAdjacentHTML(
						'beforeend',
						'<img class="pagination-loading" src="https://cdn.shopify.com/s/files/1/0497/8277/files/loader.gif?v=1618948654" />'
				);
				
				
				// Fetch content
				fetch(pInfScrURL, { method: 'GET' })
				.then(response => response.text())
				.then(data => {
					// Remove loading feedback
					if (loadingImage) {
						loadingImage.remove();
					}

					// Parse HTML string and extract content
					const tempDiv = document.createElement('div');
					tempDiv.innerHTML = data;

					const filteredData = tempDiv.querySelector('.ProductList').innerHTML;
					const productListFoot = document.querySelector('#product-list-foot');

					if (filteredData && productListFoot) {
						productListFoot.insertAdjacentHTML('beforebegin', filteredData);
						
						if (pag_wrap) {
							pag_wrap.style.display = "none";
						}
					}
					
					const next_page = tempDiv.querySelector('.p-next');
					if ( next_page ){
						pInfScrNode.setAttribute('href', next_page.getAttribute('href'));
					} else {
						pInfScrNode.remove();
					}

					pInfScrLoading = false;
					
					// Fade in products
					const productItems = document.querySelectorAll('.ProductItem');
					if (productItems.length > 0) {
						const observerOptions = {
							root: null, // Observe relative to viewport
							rootMargin: '0px',
							threshold: 0.1 // Trigger when 10% of the element is visible
						};
				
						const observer = new IntersectionObserver((entries) => {
							entries.forEach(entry => {
								entry.target.style.transform = 'matrix(1, 0, 0, 1, 0, 50)';
								entry.target.style.transition = 'transform 0.5s ease, opacity 1s ease';
								
								if (entry.isIntersecting) {
									entry.target.style.visibility = 'visible';
									entry.target.style.opacity = '1';
									entry.target.style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
									observer.unobserve(entry.target); // Stop observing once visible
								}
							});
						}, observerOptions);
				
						productItems.forEach(item => {
							if (!item.style.opacity) {
								observer.observe(item);
							}
						});
					}

					// Reset loadingCollection after delay
					setTimeout(() => {
						loadingCollection = false;
					}, 1500);
				})
				.catch(error => {
						console.error('Error loading content:', error);
						pInfScrLoading = false;
						loadingCollection = false;
				});
				
			}
		}
	}

	window.addEventListener('scroll', function() {
		function elementScrolled(elem) {
			var docViewTop = window.scrollY; // Get the current scroll position from the top
			var docViewBottom = docViewTop + window.innerHeight + 400; // Add 400px buffer
			var elemTop = elem.getBoundingClientRect().top + docViewTop; // Get the element's top position relative to the document
			
			// Return true if the element is in the viewport
			return (elemTop <= docViewBottom) && (elemTop >= docViewTop);
		}

		var pNext = document.querySelector('.p-next'); // Get the element to check

		if (pNext && elementScrolled(pNext)) {
			if (!loadingCollection) {
				pInfScrExecute();
			}
		}
	});
	
	$('.p-next').click(function(e){
		e.preventDefault();
		pInfScrExecute();
	});
}

// Select the parent container that holds dynamically added elements
const productForm = document.querySelector('.ProductForm');

if (productForm) {
	console.log('has form')
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				console.log('found')
				// Check if the added node is a <redo-shopify-checkbox>
				if (node.nodeName === 'REDO-SHOPIFY-CHECKBOX') {
					console.log('this')
					applyStyles(node);
				}
			});
		});
	});

	// Start observing for added elements
	observer.observe(productForm, { childList: true, subtree: true });

	// Function to apply styles inside shadow DOM
	function applyStyles(checkbox) {
		const shadowRoot = checkbox.shadowRoot;
		console.log('applying')
		if (shadowRoot) {
			console.log('shadow')
			console.log(shadowRoot)
			const targetElement = shadowRoot.querySelector('._4-4');
			console.log(targetElement)
			if (targetElement) {
				console.log('target found');
				targetElement.style.display = 'flex';
				targetElement.style.justifyContent = 'center';
				targetElement.style.textAlign = 'center';
			}
		}
	}

	// Also apply styles to any existing elements (if they are already in the DOM)
	document.querySelectorAll('.ProductForm redo-shopify-checkbox').forEach(applyStyles);
}